import Vue from 'vue'

const languageHeaderName = 'Content-Language'
const defaultLanguage = 'sr_latin'
const defaultCurrency = 'RSD'
const packageCurrency = 'EUR'

const exchangeRate = 118

const currencies = [
  {
    text: 'RSD',
    value: 'RSD',
  },
  {
    text: 'KM',
    value: 'KM',
  },
  {
    text: 'EUR',
    value: 'EUR',
  },
  {
    text: 'GBP',
    value: 'GBP',
  },
  {
    text: 'USD',
    value: 'USD',
  },
]

const config = {
  dateFormat: 'YYYY-MM-DD',
  dateFormatPreview: 'DD.MM.YYYY',
  firstDayOfWeek: 1,
}

// This is language keys for backend
const languageKeys = {
  sr_latin: 'sr_Latn',
  en: 'en',
  ba: 'ba',
  de: 'de',
}

function weekDayFormat(isoDate) {
  return Vue.prototype.$moment(isoDate).format('dd')
}

function monthFormat(isoDate) {
  return Vue.prototype.$moment(isoDate).format('MMM')
}

function headerDateFormat(isoDate) {
  return Vue.prototype.$moment(isoDate).format('MMMM YYYY')
}

function titleDateFormat(isoDate) {
  return Vue.prototype.$moment(isoDate).format('ddd DD. MMM')
}

export {
  currencies,
  defaultCurrency, defaultLanguage, exchangeRate, headerDateFormat, languageHeaderName,
  languageKeys, monthFormat, packageCurrency, titleDateFormat,
  weekDayFormat
}

export default config
